import { useMemo } from "react"
import { useDispatch, useSelector } from "react-redux"

import CardGrey from "../../../common/CardGrey"
import Tag from "../../../fragments/Tag"
import DeleteItem from "../Shared/DeleteItem"
import Item from "../Shared/Item"
import { caseActions } from "../../../../store/case"
import { caseQuickUpdate } from "../../../../lib/fetchApi"
import { frontendOptions, medPayMPPolicyStatusOptionsPayerTypes, medPayPIPPolicyStatusOptionsPayerTypes, medPayPolicyLimitsOptions, umPolicyLimitsOptions, umPolicyStatusOptionsPayerTypes } from "../../../../lib/systemData"
import MedpaySidebar from "./MedpaySidebar"
import PrimaryCheckbox from "../Shared/PrimaryCheckbox"
import InsuranceAddress from "../Shared/InsuranceAddress"
import GroupContainer from "../GroupNew/GroupContainer"

import { notificationActions } from "../../../../store/notifications";
import { isPipEnabledForEntry, posibleNewPrimaryMP } from "../../../../lib/verifications";
import DefaultUpdater from "../../../common/DefaultUpdater";
import CopyIconButton from "../../../fragments/CopyIconButton"

import classes from '../Shared/Item.module.css'
import { getPIPStatesDescription, getUMReducedAmount } from "../../../../lib/misc";
import { liabilityFunctions } from "../../../../lib/liability";
import { returnUMTypeLabel } from "../../../../lib/labels";
import PayerTypeStatusGlobalModal from "../../../common/modal/PayerTypeStatusGlobalModal";
// import InsuranceOwner from "./InsuranceOwner";
import InsuranceOwnerV2 from "./InsuranceOwnerV2";
import VerificationsHistory from "../verifications/VerificationsHistory";
import { copyDollarLineAlways, copyLineAlways, getInsuranceLocationContact, getLastNoteForType, hasCopyValue, joinCopyLines } from "../../../../lib/insuranceCopyNotes"

const MedpayItem = ({data, branch, lastChild}) => {
    const dispatch = useDispatch()

    let itemData = data

    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase) 
    const mpPipUm = activeCase?.mp_pip_um ?? []

    const pipEnabled = isPipEnabledForEntry(activeCase?.case?.state, data)
    const pipStateDescription = getPIPStatesDescription(data.insurance_state || activeCase?.case?.state)

    const mpPipLoc = getInsuranceLocationContact(data, "mp_pip_um", activeCase)
    const medpayLastNote = getLastNoteForType(activeCase?.notes, 2)
    const umLastNote = getLastNoteForType(activeCase?.notes, 5)

    /* Prefer um_amount_* when API sends them; otherwise UM limits live on um_policy_limit_* (UI fields). */
    const umPat = data.um_amount_patient ?? data.um_policy_limit_patient
    const umAcc = data.um_amount_accident ?? data.um_policy_limit_accident
    const umLimitParts = []
    if (hasCopyValue(umPat)) {
        umLimitParts.push(`${String(umPat).trim()}`)
    }
    if (hasCopyValue(umAcc)) {
        umLimitParts.push(`${String(umAcc).trim()}`)
    }
    const umLimitValue = umLimitParts.length ? umLimitParts.join(" / ") : null

    const mpAdjuster = data.mp_adjuster
    const mpAdjusterName = [mpAdjuster?.first_name, mpAdjuster?.last_name].filter(Boolean).join(" ").trim() || null
    const hasPipClaim = pipEnabled && Number(data.has_pip) > 0
    const hasMpClaim = Number(data.has_mp) > 0

    const medpayClaimLines = []
    if (pipEnabled && hasPipClaim && hasMpClaim) {
        medpayClaimLines.push(
            copyLineAlways("Claim No", data.pip_claim_number),
            copyLineAlways("Claim No", data.mp_claim_number),
        )
    } else if (pipEnabled && hasPipClaim) {
        medpayClaimLines.push(copyLineAlways("Claim No", data.pip_claim_number))
    } else if (hasMpClaim) {
        medpayClaimLines.push(copyLineAlways("Claim No", data.mp_claim_number))
    } else {
        medpayClaimLines.push(copyLineAlways("Claim No", null))
    }

    const medpayCopyBody = joinCopyLines([
        copyLineAlways("MP/PIP Carrier", data.insurance_carrier?.name),
        ...medpayClaimLines,
        copyLineAlways("Adjuster", mpAdjusterName),
        copyLineAlways("Adjuster Phone", mpAdjuster?.contact_information?.phone),
        copyLineAlways("Adjuster Fax", mpAdjuster?.contact_information?.fax),
        ...(pipEnabled ? [copyDollarLineAlways("PIP-$", data.pip_policy_limit)] : []),
        copyDollarLineAlways("MP-$", data.mp_policy_limit),
        copyLineAlways("Address", mpPipLoc.address1),
        copyLineAlways("Adjuster Email", mpAdjuster?.contact_information?.email),
        copyLineAlways("City", mpPipLoc.city),
        copyLineAlways("State", mpPipLoc.state),
        copyLineAlways("Zip", mpPipLoc.zip),
    ])
    const medpayCopyNotesText = `${medpayCopyBody}\n\n${copyLineAlways("Notes", medpayLastNote)}`

    const umAvailableAmount = getUMReducedAmount(
        liabilityFunctions.isLiabilityValid(activeCase?.liabilities, "policy_limit_patient"),
        data,
    )

    const umCopyBody = joinCopyLines([
        copyLineAlways("UM Carrier", data.insurance_carrier?.name),
        copyLineAlways("Claim No", data.um_claim_number),
        copyDollarLineAlways("UM-$", umLimitValue),
        copyDollarLineAlways("Available-$", umAvailableAmount),
        copyLineAlways("Address", mpPipLoc.address1),
        copyLineAlways("Adjuster Email", data.um_adjuster?.contact_information?.email),
        copyLineAlways("City", mpPipLoc.city),
        copyLineAlways("State", mpPipLoc.state),
        copyLineAlways("Zip", mpPipLoc.zip),
    ])
    const umCopyNotesText = `${umCopyBody}\n\n${copyLineAlways("Notes", umLastNote)}`


    async function rejectedNoUmHandler(data) { //if insurance is rejected set the has_um to NO UM --> 1
        let extraIdentifier = {type: 'case_mp_pip_um', field: 'has_um', type_id: itemData.id, folder: 'mp_pip_um'}
        let reqBody = {
            type: extraIdentifier.type,
            type_id: extraIdentifier.type_id,
            fields: {
                [extraIdentifier.field] : 0,
            }
        }
        if ((Number(data.data.value) === 20) && (itemData.has_um !== 0)) {
            dispatch(caseActions.modifyActiveCase({
                folder: data.identifier.folder,
                item: {
                    itemId: itemData.id,
                    field: extraIdentifier.field,
                    value: 0,
                },
            }))
            await caseQuickUpdate(userToken, activeCase.case.id, reqBody)
        }
    }
    
    async function setNewPrimaryHandler(passeData) {
        // it should not be marked as MP Exhausted already
        // it should have MP (available - checkbox)
        // it should be Verified (could be ignored if none are verified).
        if (passeData.data.value) {
            const currentItem = mpPipUm.find(item => item.id === passeData.identifier.type_id)
   
            if (currentItem && currentItem.is_primary_insurance) {
                async function tryToSetNewInsurance() {
                    const foundItems = mpPipUm.filter(item => posibleNewPrimaryMP(item, currentItem))
                    if (foundItems && foundItems.lenght > 0) {

                        let itemVerified = foundItems.find(item => item.mp_verified)   
                        if (itemVerified) { //found item that is verified
                            dispatch(caseActions.modifyActiveCase({
                                folder: 'mp_pip_um',
                                item: {
                                    itemId: itemVerified.id,
                                    field: 'is_primary_insurance',
                                    value: 1,
                                },
                                groupRelation: {
                                    field: 'is_primary_insurance',
                                    value: 0,
                                }
                            }))
            
                            for (const element of mpPipUm) {
                                if (element.id !== itemVerified.id) {
                                    if (element.is_primary_insurance) {
                                        const removeBody = {
                                            type: 'case_mp_pip_um',
                                            type_id: element.id,
                                            fields: {
                                                is_primary_insurance: false
                                            }    
                                        }
                    
                                        const update = await caseQuickUpdate(userToken, activeCase.case.id, removeBody)
                                        if (update && update.errorMessage) {
                                            dispatch(notificationActions.setError(update))
                                        }
                                    }
                                } else {
                                    const body = {
                                        type: 'case_mp_pip_um',
                                        type_id: itemVerified.id,
                                        fields: {
                                            is_primary_insurance: true
                                        }    
                                    }
                                    const update = await caseQuickUpdate(userToken, activeCase.case.id, body)
            
                                    if (update && update.errorMessage) {
                                        dispatch(notificationActions.setError(update))
                                    }    
                                }
                            }
            
                        } else { // if no item is verified than select the first one in the list
                            dispatch(caseActions.modifyActiveCase({
                                folder: 'mp_pip_um',
                                item: {
                                    itemId: foundItems[0].id,
                                    field: 'is_primary_insurance',
                                    value: 1,
                                },
                                groupRelation: {
                                    field: 'is_primary_insurance',
                                    value: 0,
                                }
                            }))
            
                            for (const element of mpPipUm) {
                                if (element.id !== foundItems[0].id) {
                                    if (element.is_primary_insurance) {
                                        const removeBody = {
                                            type: 'case_mp_pip_um',
                                            type_id: element.id,
                                            fields: {
                                                is_primary_insurance: false
                                            }    
                                        }
                    
                                        const update = await caseQuickUpdate(userToken, activeCase.case.id, removeBody)
                                        if (update && update.errorMessage) {
                                            dispatch(notificationActions.setError(update))
                                        }
                                    }
                                } else {
                                    const body = {
                                        type: 'case_mp_pip_um',
                                        type_id: foundItems[0].id,
                                        fields: {
                                            is_primary_insurance: true
                                        }    
                                    }
                                    const update = await caseQuickUpdate(userToken, activeCase.case.id, body)
            
                                    if (update && update.errorMessage) {
                                        dispatch(notificationActions.setError(update))
                                    }    
                                }
                            }
                        }  
                    }
                }
                
                if (passeData.identifier.field === 'mp_exausted' && (!currentItem.has_pip || (currentItem.has_pip && currentItem.pip_exausted))) { //the checkbox is mp_exausted and the item doesn't have pip or pip is exhausted
                    await tryToSetNewInsurance()
                } else if (passeData.identifier.field === 'pip_exausted' && (!currentItem.has_mp || (currentItem.has_mp && currentItem.mp_exausted))) {
                    await tryToSetNewInsurance()
                }

                
            }
        }
        

        
    }


    // let has_um_merge_before_update ={
    //     put_in: 'array',
    //     items: [
    //         {
    //             value_flag: 0,
    //             fields_to_modify: [
    //                 {
    //                     field: 'um_verified',
    //                     value: 0
    //                 },
    //                 {
    //                     field: 'um_verified_by',
    //                     value: null
    //                 },
    //                 {
    //                     field: 'um_verified_date',
    //                     value: null
    //                 }
    //             ]
    //         }
    //     ],
    
    // }

    const updateLinkedUMLimits = async (patientAmount, accidentAmount) => {
        dispatch(caseActions.modifyActiveCaseMultiple({
            folder: 'mp_pip_um',
            item: {
                itemId: data.id,
                fields: [
                    {
                        field: 'um_policy_limit_patient',
                        value: patientAmount
                    },
                    {
                        field: 'um_policy_limit_accident',
                        value: accidentAmount
                    }
                ]
            }
        }))

        const update = await caseQuickUpdate(userToken, activeCase.case.id, {
            type: 'case_mp_pip_um',
            type_id: data.id,
            fields: {
                um_policy_limit_patient: patientAmount,
                um_policy_limit_accident: accidentAmount
            }
        }, dispatch)

        if (update && update.errorMessage) {
            dispatch(notificationActions.setError(update))
        }
    }

    const umOptions = useMemo(() => (umPolicyLimitsOptions() || []), [])
    const umLimitPatientSuggestions = umOptions
        .filter((option) => option.active === 1 && option.amount_patient != null && option.amount_patient !== '')
        .map((option) => ({
            value: option.amount_patient,
            label: option.name,
            description: `${option.amount_patient}`,
            searchLabel: `${option.name} ${option.amount_patient} ${option.amount_insurance ?? ''}`,
            linkedValue: option.amount_insurance
        }))

    const umLimitAccidentSuggestions = umOptions
        .filter((option) => option.active === 1 && option.amount_insurance != null && option.amount_insurance !== '')
        .map((option) => ({
            value: option.amount_insurance,
            label: option.name,
            description: `${option.amount_insurance}`,
            searchLabel: `${option.name} ${option.amount_insurance} ${option.amount_patient ?? ''}`,
            linkedValue: option.amount_patient
        }))

    const medPayLimitSuggestions = useMemo(() => (medPayPolicyLimitsOptions() || [])
        .filter((option) => option.active === 1 && option.amount != null && option.amount !== '')
        .map((option) => ({
            value: option.amount,
            label: option.name,
            description: `${option.amount}`,
            searchLabel: `${option.name} ${option.amount}`
        })), [])

    

    return <Item data={data} mainItem={branch == 'medpay' ? data.is_primary_insurance : data.is_um_primary_insurance} type={'case_mp_pip_um'} folder={'mp_pip_um'} lastChild={lastChild} delete_spec={branch == 'um' ? 'um' : null}>
        <div className={classes.item_header}>
            {data.insurance_carrier && <>
                <div>
                    <div className={classes.name}>
                        {branch == "medpay" && (
                            <CopyIconButton textToCopy={medpayCopyNotesText} title="Copy MedPay notes" />
                        )}
                        {branch == "um" && (
                            <CopyIconButton textToCopy={umCopyNotesText} title="Copy UM notes" />
                        )}
                        <Tag type={'note'}>{data.insurance_carrier.code}</Tag>
                        <h2>{data.insurance_carrier.name}</h2>
                    </div>
                    {data.insurance_carrier.contact_information && <div className={classes.location}>
                        <i className='ti ti-building-skyscraper'></i>
                        <InsuranceAddress data={data} folder={'mp_pip_um'}/>
                    </div>}
                </div>
                <div className={classes.header_controls}>
                    {/* {branch == 'medpay' && <>
                        {isStateOfPip(activeCase?.case?.state) && <>
                            <IsVerifiedTag isVerified={data.pip_verified}>{data.pip_verified ? 'PIP Verified' : 'PIP Not Verified'}</IsVerifiedTag>
                        </>}
                        <IsVerifiedTag isVerified={data.mp_verified}>{data.mp_verified ? 'MP Verified' : 'MP Not Verified'}</IsVerifiedTag>
                    </>} */}
                    {branch == 'um' && <>
                        {/* <IsVerifiedTag isVerified={data.um_verified}>{data.um_verified ? 'Verified' : 'Not Verified'}</IsVerifiedTag> */}
                        <CardGrey>
                        {/* merge_before_update={has_um_merge_before_update} */}
                            <DefaultUpdater type={'radio'} value={data.has_um} options={frontendOptions()?.umHeaderRadioFields} name={'has_um'} label={'Select um status'} identifier={{type: 'case_mp_pip_um', field: 'has_um', type_id: data.id, folder: 'mp_pip_um', isUM: true}} extraOptions={{normalSize: true, isDisable: !data.um_verified}} />
                           
                        </CardGrey>
                    </>}
                    <DeleteItem data={data} type={'case_mp_pip_um'} folder={'mp_pip_um'} label={'insurance'} delete_spec={branch == 'um' ? 'um' : null} field={branch == 'um' ? 'is_um_primary_insurance' : null}/>
                </div>
            </>}
        </div>
        <div className={classes.item_inner}>
            <div className={classes.item_left}>
                <div >
                    <div className={classes.row}>
                        <CardGrey>
                            {branch == 'medpay' && <PrimaryCheckbox data={data} label={'Primary Insurance'} folder={'mp_pip_um'} apiCase={'case_mp_pip_um'} propertyName={'is_primary_insurance'}/>}
                            {branch == 'um' && <PrimaryCheckbox data={data} label={'Primary Insurance'} folder={'mp_pip_um'} apiCase={'case_mp_pip_um'} propertyName={'is_um_primary_insurance'}/>} 
                        </CardGrey>
                        
                        {/* <InsuranceOwner data={data} branch={branch}/> */}
                        <InsuranceOwnerV2 data={data} branch={branch}/>
                                             
                        
                    </div>                    

                    <div className={classes.row}>
                        <div className={classes.row_item_full}>
                            <CardGrey>
                                <div className="flex-container-equal">
                                    <DefaultUpdater type={'input'} value={data.insured_name} label={'Name of Insured'} identifier={{type: 'case_mp_pip_um', field: 'insured_name', type_id: data.id, folder: 'mp_pip_um'}} />
                                    <DefaultUpdater type={'input'} value={data.policy_number} label={'Policy Number'} identifier={{type: 'case_mp_pip_um', field: 'policy_number', type_id: data.id, folder: 'mp_pip_um'}} />
                                    {/* extraOptions={{redBorderFlag: !data.policy_number}} */}
                                    {branch == 'um' && <>
                                        <DefaultUpdater type={'input'} value={data.um_claim_number} label={'UM Claim #'} identifier={{type: 'case_mp_pip_um', field: 'um_claim_number', type_id: data.id, folder: 'mp_pip_um', isUM: true}} extraOptions={{type: 'text', redBorderFlag: !data.um_claim_number}} />
                                        <DefaultUpdater type={'input'} value={data.um_policy_limit_patient} label={'UM Limit Patient'} identifier={{type: 'case_mp_pip_um', field: 'um_policy_limit_patient', type_id: data.id, folder: 'mp_pip_um', isUM: true}} extraOptions={{format: 'currency', redBorderFlag: !data.um_policy_limit_patient, suggestions: umLimitPatientSuggestions, onSuggestionSelect: (option) => updateLinkedUMLimits(`${option.value}`, option.linkedValue != null ? `${option.linkedValue}` : '')}} />
                                        <DefaultUpdater type={'input'} value={data.um_policy_limit_accident} label={'UM Limit Accident'} identifier={{type: 'case_mp_pip_um', field: 'um_policy_limit_accident', type_id: data.id, folder: 'mp_pip_um', isUM: true}} extraOptions={{format: 'currency', suggestions: umLimitAccidentSuggestions, onSuggestionSelect: (option) => updateLinkedUMLimits(option.linkedValue != null ? `${option.linkedValue}` : '', `${option.value}`)}} />
                            
                                        <PayerTypeStatusGlobalModal date={data.um_status_date} user={data.um_status_by} isDisabled={!data.um_status}>   
                                            <DefaultUpdater type={'select'} value={Number(data.um_status)} options={umPolicyStatusOptionsPayerTypes()} label={'Claim Status'} identifier={{type: 'case_mp_pip_um', field: 'um_status', type_id: data.id, folder: 'mp_pip_um', isUM: true}} extraOptions={{hasRemove: true}} extraAction={rejectedNoUmHandler}/>
                                        </PayerTypeStatusGlobalModal> 
                                    </>}
                                    
                                    
                                </div>
                            </CardGrey>
                        </div>                        
                    </div>

                    {branch == 'medpay' && <>
                        {pipEnabled && <>
                            <div className={classes.row}>
                            <CardGrey fullWidth={true}>
                                <div className={classes.row}>
                                    <div className={classes.row_item_full}>
                                        {/* <CardGrey> */}
                                            <div className="flex-container-equal">
                                                <div className={classes.pip_state_description_container}>
                                                    <DefaultUpdater type={'radio'} name={'has_pip'} value={data.has_pip} options={frontendOptions()?.medpayPIPStatus} identifier={{type: 'case_mp_pip_um', field: 'has_pip', type_id: data.id, folder: 'mp_pip_um'}} extraOptions={{redFlag: 0, isDisable: !data.pip_verified}}/>
                                                    {pipStateDescription && <div className={classes.pip_state_description}>
                                                        {pipStateDescription}
                                                    </div>}
                                                </div>

                                                <DefaultUpdater type={'input'} value={data.pip_policy_limit} label={'PIP Limit'} identifier={{type: 'case_mp_pip_um', field: 'pip_policy_limit', type_id: data.id, folder: 'mp_pip_um'}} extraOptions={{format: 'currency', redBorderFlag: (data.mp_verified && !data.pip_policy_limit && (data.has_pip != 0)), suggestions: medPayLimitSuggestions}} />

                                                <DefaultUpdater type={'input'} value={data.pip_claim_number} label={'PIP Claim #'} identifier={{type: 'case_mp_pip_um', field: 'pip_claim_number', type_id: data.id, folder: 'mp_pip_um'}} extraOptions={{type: 'text', redBorderFlag: !data.pip_claim_number}} />

                                                <PayerTypeStatusGlobalModal date={data.pip_status_date} user={data.pip_status_by} isDisabled={!data.pip_status}>                                               
                                                    <DefaultUpdater type={'select'} value={Number(data.pip_status)} options={medPayPIPPolicyStatusOptionsPayerTypes()} label={'PIP Status'} identifier={{type: 'case_mp_pip_um', field: 'pip_status', type_id: data.id, folder: 'mp_pip_um'}} extraOptions={{hasRemove: true}}/>
                                                </PayerTypeStatusGlobalModal> 
                                                <div>
                                                    {data.has_pip != 0 && <DefaultUpdater type={'checkbox'} value={data.pip_exausted} name={'pip_exausted'} label={'PIP Exhausted'} identifier={{type: 'case_mp_pip_um', field: 'pip_exausted', type_id: data.id, folder: 'mp_pip_um'}} extraOptions={{direction: 'reverse', trueFlagDanger: true}} extraAction={setNewPrimaryHandler}/>}
                                                </div>
                                            </div>
                                        {/* </CardGrey> */}
                                    </div>                        
                                </div>
                                <div className={classes.row}>
                                    <div className={classes.row_item_full}>
                                        {/* <CardGrey> */}
                                            {branch == 'medpay' && 
                                            // <GeneralVerifiedBy data={data} folder={'mp_pip_um'} caseType={'case_mp_pip_um'} branch={branch} areFieldsNotModifiable={disableVerifySelection(data, 'medpay', 'pip')} prefix={'pip_'}/>
                                            <VerificationsHistory data={data} itemId={data.id} verificationHistory={data.pip_verification_history} folder={'mp_pip_um'} verificationField={'pip_verification_history'} mpPipUmType={'pip'} caseType={'case_mp_pip_um'}/>
                                            }                                
                                        {/* </CardGrey> */}
                                    </div>                            
                                </div>
                            </CardGrey>
                            </div>
                        </>}
                        <div className={classes.row}>
                            <CardGrey fullWidth={true}>
                                <div className={classes.row}>
                                    <div className={classes.row_item_full}>
                                        {/* <CardGrey> */}
                                            <div className="flex-container-equal">
                                                <DefaultUpdater type={'radio'} name={'has_mp'} value={data.has_mp} options={frontendOptions()?.medpayMPStatus} identifier={{type: 'case_mp_pip_um', field: 'has_mp', type_id: data.id, folder: 'mp_pip_um'}} extraOptions={{redFlag: 0, isDisable: !data.mp_verified}}/>
                                                <DefaultUpdater type={'input'} value={data.mp_policy_limit} label={'MP Limit'} identifier={{type: 'case_mp_pip_um', field: 'mp_policy_limit', type_id: data.id, folder: 'mp_pip_um'}} extraOptions={{format: 'currency', redBorderFlag: (data.mp_verified && !data.mp_policy_limit && (data.has_mp != 0)), suggestions: medPayLimitSuggestions}} />

                                                <DefaultUpdater type={'input'} value={data.mp_claim_number} label={'MP Claim #'} identifier={{type: 'case_mp_pip_um', field: 'mp_claim_number', type_id: data.id, folder: 'mp_pip_um'}} extraOptions={{type: 'text', redBorderFlag: !data.mp_claim_number}} />

                                                <PayerTypeStatusGlobalModal date={data.mp_status_date} user={data.mp_status_by} isDisabled={!data.mp_status}>   
                                                    <DefaultUpdater type={'select'} value={Number(data.mp_status)} options={medPayMPPolicyStatusOptionsPayerTypes()} label={'MP Status'} identifier={{type: 'case_mp_pip_um', field: 'mp_status', type_id: data.id, folder: 'mp_pip_um'}} extraOptions={{hasRemove: true}}/>
                                                </PayerTypeStatusGlobalModal> 
                                                <div>
                                                    {data.has_mp != 0 && <DefaultUpdater type={'checkbox'} value={data.mp_exausted} name={'mp_exausted'} label={'MP Exhausted'} identifier={{type: 'case_mp_pip_um', field: 'mp_exausted', type_id: data.id, folder: 'mp_pip_um'}} extraOptions={{direction: 'reverse', trueFlagDanger: true}} extraAction={setNewPrimaryHandler}/>}
                                                </div>
                                                                                                            
                                            </div>
                                        {/* </CardGrey> */}
                                    </div>     
                                                    
                                </div>
                                <div className={classes.row}>
                                    <div className={classes.row_item_full}>
                                        {/* <CardGrey> */}
                                            {branch == 'medpay' && 
                                            // <GeneralVerifiedBy data={data} folder={'mp_pip_um'} caseType={'case_mp_pip_um'} branch={branch} areFieldsNotModifiable={disableVerifySelection(data, 'medpay')} prefix={'mp_'}/>
                                            <VerificationsHistory data={data} itemId={data.id} verificationHistory={data.mp_verification_history} folder={'mp_pip_um'} verificationField={'mp_verification_history'} mpPipUmType={'mp'} caseType={'case_mp_pip_um'}/>
                                            }                                
                                        {/* </CardGrey> */}
                                    </div>
                                
                                </div> 
                            </CardGrey>
                        </div>
                    </>}    

                    {branch == 'um' && <div className={classes.row}>
                        <div className={classes.row_item_full}>
                            <CardGrey>
                                <VerificationsHistory data={data} itemId={data.id} verificationHistory={data.um_verification_history} folder={'mp_pip_um'} verificationField={'um_verification_history'} mpPipUmType={'um'} caseType={'case_mp_pip_um'}/>
                            </CardGrey>
                        </div>
                    </div>}

                    <div className={classes.row}>
                        <div className={classes.row_item_full}>
                            <CardGrey>
                                {/* Adjuster */}
                                {/* {branch == 'medpay' && <GeneralVerifiedBy data={data} folder={'mp_pip_um'} caseType={'case_mp_pip_um'} branch={branch} areFieldsNotModifiable={disableVerifySelection(data, 'medpay')} prefix={'mp_'}/>} */}
                                {/* {branch == 'um' && <GeneralVerifiedBy data={data} folder={'mp_pip_um'} caseType={'case_mp_pip_um'} branch={branch} areFieldsNotModifiable={disableVerifySelection(data, 'um')} prefix={'um_'} />} */}

                                {/* Location  */}
                                <div className={classes.group_container}>
                                    <GroupContainer data={data} smsMail={'Insurance Carrier'} dataId={data.id} label={'location'} folder={'mp_pip_um'} apiCase={'case_mp_pip_um'} fieldsData={{fields: ['location_id', 'location'], fieldId: 'location_id', fieldobj: 'location', group: 'locations', inputLabel: 'Location'}}/>
                                </div>

                                {/* Adjuster */}
                                {branch == 'medpay' && <div className={classes.group_container}>
                                    <GroupContainer data={data} smsMail={'Adjuster'} dataId={data.id} label={'mp_adjuster'} folder={'mp_pip_um'} apiCase={'case_mp_pip_um'} fieldsData={{fields: ['mp_adjuster_id', 'mp_adjuster'], fieldId: 'mp_adjuster_id', fieldobj: 'mp_adjuster', group: 'mp_adjuster', inputLabel: 'Adjuster'}}/>
                                </div>}
                                {branch == 'um' && <div className={classes.group_container}>
                                    <GroupContainer data={data} smsMail={'Adjuster'} dataId={data.id} label={'um_adjuster'} folder={'mp_pip_um'} apiCase={'case_mp_pip_um'} fieldsData={{fields: ['um_adjuster_id', 'um_adjuster'], fieldId: 'um_adjuster_id', fieldobj: 'um_adjuster', group: 'um_adjuster', inputLabel: 'Adjuster'}}/>
                                </div>}
                            </CardGrey>
                        </div>
                    </div>
                                        
                </div>
                
            </div>

            <div className={classes.item_right}>
                <MedpaySidebar data={data} branch={branch}/>
            </div>      
        </div> 

        
    </Item>
}

export default MedpayItem